import { render, staticRenderFns } from "./AudioPlayer.vue?vue&type=template&id=1f5e7004&scoped=true"
import script from "./AudioPlayer.vue?vue&type=script&lang=ts"
export * from "./AudioPlayer.vue?vue&type=script&lang=ts"
import style0 from "./AudioPlayer.vue?vue&type=style&index=0&id=1f5e7004&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5e7004",
  null
  
)

export default component.exports